<template>
  <div class="tw-flex tw-flex-wrap tw-gap-1">
    <template v-if="orders && orders.length > 0">
      <template v-for="(order, index) in orders" :key="order.id">
        <router-link
          :to="{ name: 'order', params: { id: order.id } }"
          class="tw-underline tw-text-primary-500 hover:tw-text-primary-700 tw-cursor-pointer"
        >
          {{ order.order_number }}
        </router-link>
        <span v-if="index < orders.length - 1">,</span>
      </template>
    </template>
    <span v-else>-</span>
  </div>
</template>

<script setup lang="ts">
import type { CellContext } from '@tanstack/vue-table';
import { computed } from 'vue';

const props = defineProps<{
  info: CellContext<any, any>;
}>();

const orders = computed(() => props.info.row.original.orders);
</script>
